import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Snackbar,
  Alert,
  LinearProgress,
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Chip,
  Tab,
  Tabs,
} from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import {
  Security as SecurityIcon,
  Edit as EditIcon,
  Group as GroupIcon,
  Person as PersonIcon,
  Assignment as AssignmentIcon,
} from "@mui/icons-material";
import "./PermissionOverview.css";
import { getToken, getUser } from "services/auth.service";
import { usePageTitle } from "context/PageTitleContext";
import { checkPermission } from "services/permission.service";
import { PERMISSIONS } from "auth/permissionCodes";
import { getActionColor, getModuleShortName, getActionLabel, getRoleColor } from "modules/systems/utils/permission.utils";
import DataTable from "components/common/tables/DataTable"
import { AppTab, AppTabPanel } from "components/common/tabs";
import { AppStatCard, AppStatGrid } from "components/common/cards";
import { AppButton } from "components/common/buttons";

const PermissionOverview = () => {
  const { setPageTitle } = usePageTitle();
  const [loading, setLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [permissionsTableKey, setPermissionsTableKey] = useState(0);

  const tabs = [
    { label: "Quyền hạn", icon: <SecurityIcon />, value: 0 },
    { label: "Vai trò", icon: <GroupIcon />, value: 1 },
    { label: "Người dùng", icon: <PersonIcon />, value: 2 },
  ];

  // Modal dialog hiển thị danh sách user của vai trò
  const renderViewUsersDialog = () => {
    if (!viewUsersDialogOpen) return null;
    // Filter theo search
    const filtered = usersOfRole.filter(
      (u) =>
        u.userName?.toLowerCase().includes(usersOfRoleSearch.toLowerCase()) ||
        u.fullName?.toLowerCase().includes(usersOfRoleSearch.toLowerCase())
    );
    // Phân trang
    const columns = [
      { accessorKey: "userName", header: "Tên đăng nhập", size: 80 },
      { accessorKey: "fullName", header: "Tên đầy đủ", size: 120 },
    ];
    return (
      <Dialog
        open={viewUsersDialogOpen}
        maxWidth="md"
        fullWidth
        onClose={() => setViewUsersDialogOpen(false)}
      >
        <DialogTitle>
          Người dùng của vai trò: <b>{selectedRoleForUsers?.roleName}</b>
        </DialogTitle>
        <DialogContent>
          <TextField
            label="Tìm kiếm người dùng"
            value={usersOfRoleSearch}
            onChange={(e) => {
              setUsersOfRoleSearch(e.target.value);
              setUsersOfRolePage(0);
            }}
            fullWidth
            margin="normal"
          />
          {/* <MaterialReactTable */}
          <DataTable
            columns={columns}
            data={filtered}
            enableColumnActions={false}
            enableRowSelection={false}
            initialState={{
              pagination: { pageIndex: 0, pageSize: usersOfRoleRowsPerPage },
              density: "compact",
            }}
          // muiTablePaperProps={{
          //   elevation: 0,
          //   sx: { border: "1px solid #e0e0e0" },
          // }}
          // localization={MRT_Localization_VI}
          // initialState={{ density: "compact" }}
          // state={{
          //   pagination: {
          //     pageIndex: usersOfRolePage,
          //     pageSize: usersOfRoleRowsPerPage,
          //   },
          // }}
          // onPaginationChange={(newState) => {
          //   setUsersOfRolePage(newState.pageIndex ?? 0);
          //   setUsersOfRoleRowsPerPage(
          //     newState.pageSize ?? usersOfRoleRowsPerPage
          //   );
          // }}
          // rowCount={filtered.length}
          // manualPagination
          />
        </DialogContent>
        <DialogActions>
          <AppButton variant="outlined" onClick={() => setViewUsersDialogOpen(false)}>
            Đóng
          </AppButton>
        </DialogActions>
      </Dialog>
    );
  };
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const [permissions, setPermissions] = useState([]);
  const [roles, setRoles] = useState([]);
  const [users, setUsers] = useState([]);
  const [userRoles, setUserRoles] = useState([]);
  const [rolePermissions, setRolePermissions] = useState([]);
  const [userPermissions, setUserPermissions] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editPermission, setEditPermission] = useState(null);
  const [editDescription, setEditDescription] = useState("");
  const [savingEdit, setSavingEdit] = useState(false);
  const [rolePermDialogOpen, setRolePermDialogOpen] = useState(false);
  const [selectedRoleForPerm, setSelectedRoleForPerm] = useState(null);
  const [selectedRolePerms, setSelectedRolePerms] = useState([]);
  const [loadingRolePerms, setLoadingRolePerms] = useState(false);
  const [rolePermsFetched, setRolePermsFetched] = useState(false);
  // State cho modal xem người dùng của vai trò
  const [viewUsersDialogOpen, setViewUsersDialogOpen] = useState(false);
  const [selectedRoleForUsers, setSelectedRoleForUsers] = useState(null);
  const [usersOfRole, setUsersOfRole] = useState([]);
  const [loadingUsersOfRole, setLoadingUsersOfRole] = useState(false);
  const [usersOfRoleSearch, setUsersOfRoleSearch] = useState("");
  const [usersOfRolePage, setUsersOfRolePage] = useState(0);
  const [usersOfRoleRowsPerPage, setUsersOfRoleRowsPerPage] = useState(10);

  // Set page title
  useEffect(() => {
    setPageTitle("Phân quyền");
  }, [setPageTitle]);

  useEffect(() => {
    loadData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function loadData() {
    setLoading(true);
    try {
      await Promise.all([
        loadPermissions(),
        loadRoles(),
        loadUsers(),
        loadUserRoles(),
        loadRolePermissions(),
        loadUserPermissions(),
      ]);
    } catch (error) {
      showSnackbar("Lỗi khi tải dữ liệu", "error");
    } finally {
      setLoading(false);
    }
  }

  async function loadPermissions() {
    try {
      const token = getToken();
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/SystemPermissions/all`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.ok) {
        const json = await response.json();
        setPermissions(json.data || json.Data || []);
      }
    } catch (error) {
      console.error("Error loading permissions:", error);
    }
  }

  async function loadRoles() {
    try {
      const token = getToken();
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/RolesManagement?pageSize=1000&pageNumber=1`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.ok) {
        const data = await response.json();
        setRoles(data.data || []);
      }
    } catch (error) {
      console.error("Error loading roles:", error);
    }
  }

  async function loadUsers() {
    try {
      const token = getToken();
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/User?pageSize=1000&pageNumber=1`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.ok) {
        const data = await response.json();
        setUsers(data.data || []);
      }
    } catch (error) {
      console.error("Error loading users:", error);
    }
  }

  async function loadUserRoles() {
    try {
      const token = getToken();
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/UserRole?pageSize=1000&pageNumber=1`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.ok) {
        const data = await response.json();
        setUserRoles(data.data || []);
      }
    } catch (error) {
      console.error("Error loading user roles:", error);
    }
  }

  async function loadRolePermissions() {
    try {
      const token = getToken();
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/RolePermission?pageSize=1000&pageNumber=1`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.ok) {
        const data = await response.json();
        setRolePermissions(data.data || []);
      }
    } catch (error) {
      console.error("Error loading role permissions:", error);
    }
  }

  async function loadUserPermissions() {
    try {
      const token = getToken();
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/UserPermission?pageSize=1000&pageNumber=1`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.ok) {
        const data = await response.json();
        setUserPermissions(data.data || []);
      }
    } catch (error) {
      console.error("Error loading user permissions:", error);
    }
  }

  const showSnackbar = (message, severity = "info") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setPage(0);
    setSearchTerm("");
    if (newValue === 0) {
      setPermissionsTableKey((k) => k + 1);
      loadPermissions();
    }
  };

  // Hàm xử lý khi nhấn nút xem người dùng của vai trò
  const handleViewUsersOfRole = (role) => {
    setSelectedRoleForUsers(role);
    setViewUsersDialogOpen(true);
    setLoadingUsersOfRole(true);
    // Lấy danh sách user có vai trò này
    const roleId = role?.roleId ?? role?.RoleId ?? role?.id ?? role?.Id;
    // Lọc userRoles để lấy userId
    const userIds = userRoles
      .filter((ur) => String(ur.roleId) === String(roleId))
      .map((ur) => ur.userId);
    // Lọc users theo userIds
    const usersList = users.filter((u) => userIds.includes(u.userId));
    setUsersOfRole(usersList);
    setLoadingUsersOfRole(false);
    setUsersOfRoleSearch("");
    setUsersOfRolePage(0);
  };

  const handleViewRolePermissions = async (role) => {
    const roleName = (role?.roleName || role?.RoleName || "").toLowerCase();
    if (roleName === "admin") {
      showSnackbar("Vai trò Admin có toàn quyền", "info");
      return;
    }

    const roleIdValue = role?.roleId ?? role?.RoleId ?? role?.id ?? role?.Id;


    setSelectedRoleForPerm(role);
    setRolePermDialogOpen(true);
    setLoadingRolePerms(true);
    setRolePermsFetched(false);
    try {
      const token = getToken();
      const url = `${process.env.REACT_APP_API_URL
        }/api/RolePermission/role/${encodeURIComponent(
          String(roleIdValue ?? "")
        )}?pageSize=1000&pageNumber=1`;
      const resp = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const json = resp.ok ? await resp.json() : null;
      const fresh = json ? json.data || json.Data || [] : rolePermissions;
      if (resp.ok) {
        const isRoleScoped =
          (Array.isArray(fresh) &&
            fresh.length > 0 &&
            String(
              fresh[0]?.roleId ?? fresh[0]?.RoleId ?? fresh[0]?.roleID ?? ""
            ) === String(roleIdValue)) ||
          String(url).includes("/role/");

        if (isRoleScoped && roleIdValue != null) {
          setRolePermissions((prev = []) => {
            const filtered = prev.filter(
              (rp) =>
                String(rp?.roleId ?? rp?.RoleId ?? rp?.id ?? "") !==
                String(roleIdValue)
            );
            return [...filtered, ...(fresh || [])];
          });
        } else {
          setRolePermissions(fresh);
        }
      }

      const rpForRole = (fresh || rolePermissions).filter((rp) => {
        const rid =
          rp?.roleId ?? rp?.RoleId ?? rp?.RoleID ?? rp?.roleID ?? rp?.roleId;
        return String(rid) === String(roleIdValue);
      });

      const perms = rpForRole.map((rp) => {
        const rpPermId =
          rp?.permissionId ??
          rp?.PermissionId ??
          rp?.PermissionID ??
          rp?.permissionID ??
          rp?.permId;
        const perm = permissions.find((p) => {
          const pid =
            p?.permissionId ??
            p?.PermissionId ??
            p?.PermissionID ??
            p?.permissionID ??
            p?.id ??
            p?.Id;
          return String(pid) === String(rpPermId);
        });

        if (perm) {
          return {
            permissionId: perm?.permissionId ?? perm?.PermissionId ?? perm?.id,
            permissionName:
              perm?.permissionName ?? perm?.PermissionName ?? perm?.name ?? "",
            description: perm?.description ?? perm?.Description ?? "",
          };
        }

        return {
          permissionId:
            rpPermId ?? rp?.permissionId ?? rp?.PermissionId ?? rp?.id,
          permissionName:
            rp?.permissionName ?? rp?.PermissionName ?? String(rpPermId ?? ""),
          description: rp?.description ?? rp?.Description ?? "",
        };
      });

      const finalPerms = Array.isArray(perms) ? perms : [];


      setSelectedRoleForPerm(role);
      setSelectedRolePerms(Array.isArray(finalPerms) ? [...finalPerms] : []);

      setRolePermsFetched(true);
      setLoadingRolePerms(false);
    } catch (err) {
      console.error("Error loading role permissions:", err);
      const rpForRole = rolePermissions.filter(
        (rp) =>
          String(rp?.roleId ?? rp?.RoleId ?? rp?.id) === String(roleIdValue)
      );
      const perms = rpForRole.map((rp) => ({
        permissionId: rp?.permissionId ?? rp?.PermissionId ?? rp?.id,
        permissionName:
          rp?.permissionName ??
          rp?.PermissionName ??
          String(rp?.permissionId ?? ""),
        description: rp?.description ?? rp?.Description ?? "",
      }));
      setSelectedRoleForPerm(role);
      setSelectedRolePerms(perms);
      setRolePermsFetched(true);
      setLoadingRolePerms(false);
    }
  };

  const getPermissionStats = () => {
    const totalPermissions = permissions.length;
    const usedPermissions = new Set([
      ...rolePermissions.map((rp) => rp.permissionId),
      ...userPermissions.map((up) => up.permissionId),
    ]).size;
    return {
      total: totalPermissions,
      used: usedPermissions,
      unused: totalPermissions - usedPermissions,
    };
  };

  const getRoleStats = () => {
    const totalRoles = roles.length;
    const usedRoles = new Set(userRoles.map((ur) => ur.roleId)).size;
    return {
      total: totalRoles,
      used: usedRoles,
      unused: totalRoles - usedRoles,
    };
  };

  const getUserStats = () => {
    const totalUsers = users.length;
    const activeUsers = users.filter((u) => u.isActive).length;
    const usersWithRoles = new Set(userRoles.map((ur) => ur.userId)).size;

    return {
      total: totalUsers,
      active: activeUsers,
      withRoles: usersWithRoles,
      withoutRoles: totalUsers - usersWithRoles,
    };
  };

  // const getActionColor = (action) => {
  //   const colors = {
  //     read: "primary",
  //     create: "success",
  //     update: "warning",
  //     delete: "error",
  //   };
  //   return colors[action] || "default";
  // };

  const handleSaveEdit = async () => {
    if (!editPermission) return;
    setSavingEdit(true);
    try {
      const token = getToken();
      const user = getUser();
      const updateBy = user?.userName || user?.userId || "system";

      const resp = await fetch(
        `${process.env.REACT_APP_API_URL}/api/SystemPermissions/${editPermission.permissionId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ description: editDescription, updateBy }),
        }
      );

      if (!resp.ok) throw new Error("Update failed");

      setPermissions((prev) =>
        prev.map((p) =>
          p.permissionId === editPermission.permissionId
            ? { ...p, description: editDescription }
            : p
        )
      );
      showSnackbar("Cập nhật mô tả quyền thành công", "success");
      setEditDialogOpen(false);
    } catch (error) {
      console.error("Error saving edit:", error);
      showSnackbar("Lưu thay đổi thất bại", "error");
    } finally {
      setSavingEdit(false);
    }
  };

  // Hàm xử lý chỉnh sửa mô tả quyền với kiểm tra phân quyền
  const handleEditPermission = async (permission) => {
    const result = await checkPermission(PERMISSIONS.SYSTEM.PERMISSION_FUNCTION_ASSIGN);
    if (result.hasPermission) {
      setEditPermission(permission);
      setEditDescription(permission.description || "");
      setEditDialogOpen(true);
    } else {
      showSnackbar("Bạn không có quyền chỉnh sửa mô tả quyền.", "warning");
    }
  };

  const renderOverviewCards = () => {
    const permissionStats = getPermissionStats();
    const roleStats = getRoleStats();
    const userStats = getUserStats();

    return (
      // <Grid container spacing={3} sx={{ mb: 3 }}>
      //   <Grid item xs={12} md={4}>
      //     <Card>
      //       <CardContent>
      //         <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
      //           <SecurityIcon color="primary" sx={{ mr: 1 }} />
      //           <Typography variant="h6">Quyền hạn</Typography>
      //         </Box>
      //         <Typography variant="h4" color="primary" sx={{ mb: 1 }}>
      //           {permissionStats.total}
      //         </Typography>
      //         <Typography variant="body2" color="text.secondary">
      //           Đã sử dụng: {permissionStats.used} | Chưa sử dụng:{" "}
      //           {permissionStats.unused}
      //         </Typography>
      //       </CardContent>
      //     </Card>
      //   </Grid>

      //   <Grid item xs={12} md={4}>
      //     <Card>
      //       <CardContent>
      //         <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
      //           <GroupIcon color="secondary" sx={{ mr: 1 }} />
      //           <Typography variant="h6">Vai trò</Typography>
      //         </Box>
      //         <Typography variant="h4" color="secondary" sx={{ mb: 1 }}>
      //           {roleStats.total}
      //         </Typography>
      //         <Typography variant="body2" color="text.secondary">
      //           Đã gán: {roleStats.used} | Chưa gán: {roleStats.unused}
      //         </Typography>
      //       </CardContent>
      //     </Card>
      //   </Grid>

      //   <Grid item xs={12} md={4}>
      //     <Card>
      //       <CardContent>
      //         <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
      //           <PersonIcon color="success" sx={{ mr: 1 }} />
      //           <Typography variant="h6">Người dùng</Typography>
      //         </Box>
      //         <Typography variant="h4" color="success" sx={{ mb: 1 }}>
      //           {userStats.total}
      //         </Typography>
      //         <Typography variant="body2" color="text.secondary">
      //           Hoạt động: {userStats.active} | Có vai trò:{" "}
      //           {userStats.withRoles}
      //         </Typography>
      //       </CardContent>
      //     </Card>
      //   </Grid>
      // </Grid>
      <AppStatGrid>
        <AppStatCard
          label="Quyền hạn"
          value={permissionStats.total}
          icon={<SecurityIcon />}
          rows={[
            { label: "Đã sử dụng", value: permissionStats.used, color: "#16a34a" },
            { label: "Chưa sử dụng", value: permissionStats.unused, color: "#f59e0b" },
          ]}
        />

        <AppStatCard
          label="Vai trò"
          value={roleStats.total}
          icon={<GroupIcon />}
          rows={[
            { label: "Đã gán", value: roleStats.used, color: "#7c3aed" },
            { label: "Chưa gán", value: roleStats.unused, color: "#64748b" },
          ]}
        />

        <AppStatCard
          label="Người dùng"
          value={userStats.total}
          icon={<PersonIcon />}
          rows={[
            { label: "Hoạt động", value: userStats.active, color: "#16a34a" },
            { label: "Có vai trò", value: userStats.withRoles, color: "#2563eb" },
          ]}
        />
      </AppStatGrid>
    );
  };

  const renderPermissionsTab = () => {
    const filteredPermissions = permissions.filter(
      (permission) =>
        permission.permissionName
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        permission.description?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    // console.log(filteredPermissions)

    const columns = [
      { accessorKey: "permissionId", header: "ID" },
      {
        accessorKey: "stt", header: "STT", size: 30,
        Cell: ({ row }) => row.index + 1
      },
      {
        accessorKey: "permissionDisplayName", header: "Tên quyền", size: 200,
        muiTableBodyCellProps: () => {
          return {
            align: 'left',
          };
        },
      },
      { accessorKey: "permissionCode", header: "Mã quyền", size: 240, },
      {
        accessorKey: "description", header: "Mô tả", size: 200,
        muiTableBodyCellProps: () => {
          return {
            align: 'left',
          };
        },
      },
      // {
      //   id: "field",
      //   header: "Loại",
      //   accessorFn: (row) => row.permissionName?.split(":")[1] || "",
      //   Cell: ({ cell }) => (
      //     <Chip
      //       label={cell.getValue() === "all" ? "Tổng quát" : "Cụ thể"}
      //       size="small"
      //       color={cell.getValue() === "all" ? "primary" : "default"}
      //     />
      //   ),
      //   size: 100,
      // },
      {
        // id: "resource",
        accessorKey: "moduleCode",
        header: "Ứng dụng",
        // accessorFn: (row) => row.permissionName?.split(":")[0] || "",
        Cell: ({ cell }) => (
          <Chip label={getModuleShortName(cell.getValue())} size="small" variant="outlined" />
        ),
        size: 90,
      },
      {
        accessorKey: "actionCode",
        header: "Hành động",
        // accessorFn: (row) => row.permissionName?.split(":")[2] || "",
        Cell: ({ cell }) => (
          <Chip
            label={getActionLabel(cell.getValue())}
            size="small"
            color={getActionColor(cell.getValue())}
          />
        ),
        size: 80,
      },
      {
        id: "used",
        header: "Sử dụng",
        accessorFn: (row) =>
          rolePermissions.some((rp) => rp.permissionId === row.permissionId) ||
          userPermissions.some((up) => up.permissionId === row.permissionId),
        Cell: ({ cell }) => (
          <Chip
            label={cell.getValue() ? "Đã sử dụng" : "Chưa sử dụng"}
            size="small"
            color={cell.getValue() ? "success" : "default"}
          />
        ),
        size: 120,
      },
      {
        id: "actions",
        header: "Thao tác",
        enableSorting: false,
        enableColumnActions: false,
        Cell: ({ row }) => (
          <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
            <Tooltip title="Chỉnh sửa">
              <IconButton
                size="small"
                onClick={() => handleEditPermission(row.original)}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          </Box>
        ),
        size: 60,
      },
    ];

    return (
      // <MaterialReactTable
      <DataTable
        key={`permissions-table-${permissionsTableKey}`}
        columns={columns}
        data={filteredPermissions}
        // enableColumnActions={false}
        // enableColumnPinning
        // enableRowSelection={false}
        // muiTablePaperProps={{
        //   elevation: 0,
        //   sx: { border: "1px solid #e0e0e0" },
        // }}
        // localization={MRT_Localization_VI}
        // enableStickyHeader
        initialState={{
          columnVisibility: { permissionId: false },
          // columnPinning: { left: ["stt", "permissionName"] },
          pagination: { pageIndex: 0, pageSize: 10 },
          density: "compact",
        }}
      />
    );
  };

  const renderRolesTab = () => {
    const filteredRoles = roles.filter(
      (role) =>
        role.roleName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        role.description?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const columns = [
      { accessorKey: "roleId", header: "ID", size: 60 },
      {
        accessorKey: "stt", header: "STT",
        Cell: ({ row }) => row.index + 1
      },
      {
        accessorKey: "roleName",
        header: "Tên vai trò",
        Cell: ({ row }) => (
          // <Typography variant="subtitle2">
          //   {row.original.roleName}
          // </Typography>
          <Chip
            label={row.original.roleName}
            size="small"
            sx={
              getRoleColor(row.original.roleName)
                ? { backgroundColor: getRoleColor(row.original.roleName), color: "#fff" }
                : {}
            }
            variant={getRoleColor(row.original.roleName) ? "filled" : "outlined"}
          />
        ),
      },
      {
        accessorKey: "description", header: "Mô tả",
        muiTableBodyCellProps: () => {
          return {
            align: 'left',
          };
        },
      },
      {
        id: "permissionCount",
        header: "Số quyền",
        accessorFn: (row) =>
          rolePermissions.filter((rp) => rp.roleId === row.roleId).length,
        Cell: ({ row, cell }) => {
          const roleName = (row?.original?.roleName || "").toLowerCase();
          if (roleName === "admin")
            return <Chip label="Toàn quyền" size="small" color="success" />;
          return (
            <Chip
              label={String(cell.getValue())}
              size="small"
              color="primary"
            />
          );
        },
      },
      {
        id: "userCount",
        header: "Số người dùng",
        accessorFn: (row) =>
          userRoles.filter((ur) => ur.roleId === row.roleId).length,
        Cell: ({ cell }) => (
          <Chip label={cell.getValue()} size="small" color="secondary" />
        ),
      },
      {
        id: "status",
        header: "Trạng thái",
        accessorFn: (row) =>
          userRoles.filter((ur) => ur.roleId === row.roleId).length > 0,
        Cell: ({ cell }) => (
          <Chip
            label={cell.getValue() ? "Đang sử dụng" : "Chưa sử dụng"}
            size="small"
            color={cell.getValue() ? "success" : "default"}
          />
        ),
      },
      {
        id: "actions",
        header: "Thao tác",
        enableSorting: false,
        enableColumnActions: false,
        Cell: ({ row }) => (
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Tooltip title="Xem quyền">
              <IconButton
                size="small"
                onClick={() => handleViewRolePermissions(row.original)}
              >
                <SecurityIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Xem người dùng">
              <IconButton
                size="small"
                onClick={() => handleViewUsersOfRole(row.original)}
              >
                <PersonIcon />
              </IconButton>
            </Tooltip>
          </Box>
        ),
        size: 80,
      },
    ];

    return (
      // <MaterialReactTable
      <DataTable
        columns={columns}
        data={filteredRoles}
        enableColumnActions={false}
        enableRowSelection={false}
        initialState={{
          columnVisibility: { roleId: false },
          // columnPinning: { left: ["stt", "roleName"] },
          pagination: { pageIndex: 0, pageSize: 10 },
        }}
      // muiTablePaperProps={{
      //   elevation: 0,
      //   sx: { border: "1px solid #e0e0e0" },
      // }}
      // localization={MRT_Localization_VI}
      // initialState={{ density: "compact" }}
      // state={{ pagination: { pageIndex: page, pageSize: rowsPerPage } }}
      // onPaginationChange={(newState) => {
      //   setPage(newState.pageIndex ?? 0);
      //   setRowsPerPage(newState.pageSize ?? rowsPerPage);
      // }}
      />
    );
  };

  const renderUsersTab = () => {
    const filteredUsers = users.filter(
      (user) =>
        user.fullName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.userName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.email?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const columns = [
      { accessorKey: "userId", header: "ID", size: 60 },
      {
        accessorKey: "stt", header: "STT",
        Cell: ({ row }) => row.index + 1
      },
      {
        accessorKey: "fullName",
        header: "Tên đầy đủ",
        muiTableBodyCellProps: () => {
          return {
            align: 'left',
          };
        },
        Cell: ({ row }) => (
          <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
            {row.original.fullName}
          </Typography>
        ),
      },
      {
        accessorKey: "userName",
        header: "Tên đăng nhập",
        Cell: ({ row }) => row.original.userName,
      },
      { accessorKey: "email", header: "Email" },
      {
        id: "roles",
        header: "Vai trò",
        accessorFn: (row) => {
          // Lấy danh sách roleId của user
          const roleIds = userRoles
            .filter((ur) => ur.userId === row.userId)
            .map((ur) => ur.roleId);
          // Lấy tên vai trò từ danh sách roleId
          return roles
            .filter((r) => roleIds.includes(r.roleId))
            .map((r) => r.roleName);
        },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (!value || value.length === 0)
            return <Chip label="Không có" size="small" color="default" />;
          // Hàm lấy màu cho từng vai trò
          // const getRoleColor = (roleName) => {
          //   if (roleName === "Admin") return "#9c27b0";
          //   if (roleName === "Operator") return "#2196f3";
          //   if (roleName === "Creator") return "#4caf50";
          //   if (roleName === "Viewer") return "#798e01ff";
          //   return undefined;
          // };
          return (
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 0.5,
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              {value.map((role, idx) => (
                <Chip
                  key={idx}
                  label={role}
                  size="small"
                  sx={
                    getRoleColor(role)
                      ? { backgroundColor: getRoleColor(role), color: "#fff" }
                      : {}
                  }
                  variant={getRoleColor(role) ? "filled" : "outlined"}
                />
              ))}
            </Box>
          );
        },
      },
      {
        id: "status",
        header: "Trạng thái",
        accessorFn: (row) => !!row.isActive,
        Cell: ({ cell }) => (
          <Chip
            label={cell.getValue() ? "Đã kích hoạt" : "Chưa kích hoạt"}
            size="small"
            sx={{
              backgroundColor: cell.getValue() ? "#4caf50" : "#ff9800",
              color: "#fff",
            }}
          />
        ),
      },
      // Đã xóa cột Thao tác theo yêu cầu
    ];

    return (
      // <MaterialReactTable
      <DataTable
        columns={columns}
        data={filteredUsers}
        enableColumnActions={false}
        enableRowSelection={false}
        initialState={{
          columnVisibility: { userId: false },
          columnPinning: { left: ["stt", "fullName"] },
          pagination: { pageIndex: 0, pageSize: 10 },
        }}
      // muiTablePaperProps={{
      //   elevation: 0,
      //   sx: { border: "1px solid #e0e0e0" },
      // }}
      // localization={MRT_Localization_VI}
      // initialState={{
      //   density: "compact",
      //   pagination: { pageIndex: 0, pageSize: 10 },
      // }}
      // state={{ pagination: { pageIndex: page, pageSize: rowsPerPage } }}
      // onPaginationChange={(newState) => {
      //   setPage(newState.pageIndex ?? 0);
      //   setRowsPerPage(newState.pageSize ?? rowsPerPage);
      // }}
      />
    );
  };

  return (
    <Box className="permission-overview tab-content">
      {loading && <LinearProgress sx={{ mb: 2 }} />}
      {renderOverviewCards()}
      <Paper elevation={0} sx={{ border: "1px solid #e0e0e0" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          {/* <Tabs
            value={tabValue}
            onChange={handleTabChange}
            sx={{
              "& .MuiTab-root": {
                fontFamily: "Inter, sans-serif",
              },
            }}
          >
            <Tab label="Quyền hạn" icon={<SecurityIcon />} />
            <Tab label="Vai trò" icon={<GroupIcon />} />
            <Tab label="Người dùng" icon={<PersonIcon />} />
          </Tabs> */}
          <AppTab
            value={tabValue}
            onChange={handleTabChange}
            tabs={tabs}
          />
        </Box>
        <Box sx={{ p: 2 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
              flexDirection: "row-reverse",
            }}
          >
            {/* Reload button removed per request */}
          </Box>
          {/* {tabValue === 0 && renderPermissionsTab()}
          {tabValue === 1 && (
            <>
              {renderRolesTab()}
              {renderViewUsersDialog()}
            </>
          )}
          {tabValue === 2 && renderUsersTab()} */}
          <AppTabPanel value={tabValue} index={0}>
            {tabValue === 0 && renderPermissionsTab()}
          </AppTabPanel>

          <AppTabPanel value={tabValue} index={1}>
            <>
              {renderRolesTab()}
              {renderViewUsersDialog()}
            </>
          </AppTabPanel>

          <AppTabPanel value={tabValue} index={2}>
            {tabValue === 2 && renderUsersTab()}
          </AppTabPanel>
        </Box>
      </Paper>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3500}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Dialog
        open={editDialogOpen}
        onClose={() => setEditDialogOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ pb: 1 }}>Chỉnh sửa mô tả quyền</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            multiline
            minRows={3}
            value={editDescription}
            onChange={(e) => setEditDescription(e.target.value)}
            label="Mô tả"
            variant="outlined"
            sx={{
              "& .MuiInputLabel-root": {
                backgroundColor: "background.paper",
                px: 0.5,
              },
              marginTop: "8px",
            }}
          />
        </DialogContent>
        <DialogActions>
          <AppButton variant="outlined" onClick={() => setEditDialogOpen(false)}>Hủy</AppButton>
          <AppButton
            onClick={handleSaveEdit}
            variant="contained"
            disabled={savingEdit}
          >
            Lưu
          </AppButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={rolePermDialogOpen}
        onClose={() => setRolePermDialogOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          Quyền của vai trò <b>{selectedRoleForPerm?.roleName || ""}</b>
        </DialogTitle>
        <DialogContent>
          {loadingRolePerms && (
            <Typography variant="body2">Đang tải quyền...</Typography>
          )}
          <Typography variant="body2" sx={{ mb: 1 }}>
            Hiển thị {selectedRolePerms.length} quyền
          </Typography>
          {/* <MaterialReactTable */}
          <DataTable
            columns={[
              { accessorKey: "permissionId", header: "ID", size: 60 },
              {
                accessorKey: "permissionName",
                header: "Tên quyền",
                size: 240,
              },
              { accessorKey: "description", header: "Mô tả", size: 300 },
            ]}
            data={selectedRolePerms}
            getRowId={(row) => row.permissionId}
            enableColumnActions={false}
            initialState={{
              pagination: { pageIndex: 0, pageSize: 10 },
              density: "compact",
            }}
          // enableRowSelection={false}
          // muiTablePaperProps={{
          //   elevation: 0,
          //   sx: { border: "1px solid #e0e0e0" },
          // }}
          // localization={MRT_Localization_VI}
          // initialState={{
          //   density: "compact",
          //   pagination: { pageSize: 10 },
          // }}
          />
        </DialogContent>
        <DialogActions>
          <AppButton variant="outlined" onClick={() => setRolePermDialogOpen(false)}>
            Đóng
          </AppButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PermissionOverview;
